import useSWR from "swr";

import getData from "../APICalls/getData";
import getBuyerAPIDomain from "../APICalls/getBuyerAPIDomain";
import accountDataPush from "../AdobeDataPushes/accountDataPush";
import { useAuth } from "@bca-auth0/bca-auth0-provider";

export function useGetExportFlag(isToUseAuthZero: boolean) {
  const { accessToken } = useAuth(!isToUseAuthZero);
  const buyerAPIDomain = getBuyerAPIDomain(isToUseAuthZero);
  const getExportFlagUrl = buyerAPIDomain
    ? new URL(`${buyerAPIDomain.href}/customer/account`, buyerAPIDomain)
    : null;

  const shouldCallAPI =
    accessToken || !isToUseAuthZero ? getExportFlagUrl.href : null;
  const swrKey = shouldCallAPI
    ? [shouldCallAPI, accessToken, isToUseAuthZero]
    : null;

  const { data } = useSWR(swrKey, getData, {
    onSuccess: accountDataPush,
    revalidateOnFocus: false,
  });

  return { hasExportAccount: data?.hasExportAccount };
}
